import { lazy } from 'react';

export const PracticePage = lazy(() => import('./PracticePage'));
